module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_hiroshima-dd436b3fc675abb80745343d2d0f6518.jpg";